import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import { Card } from "primereact/card";
import { ITrainingSchedules } from "./Table";

interface IProps {
    open: boolean,
    singleData: ITrainingSchedules,
    hideDialog: () => void,
    toast: any,
    reloadTable: () => void,
}

const schema = yup.object({
    rejection_Comment: yup.string().required("Rejection Comment is required*"),
});

export const ApproveSchedulerForm = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [openRej, setOpenRej] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<ITrainingSchedules>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const onApprove = async () => {
        setLoading(true);
        const response = await Fetch("CarnivalTraining/updateTrainingSchedulesFormAction", "PUT", { Schedule_ID: props.singleData.schedule_ID, Schedule_Status: true, Rejection_Comment: null }, null, props.toast);

        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
            onHide();
        } else setLoading(false);
    }
    const onReject = async () => {
        setOpenRej(true);
    }
    const onHide = () => {
        reset({ rejection_Comment: "" });
        setOpenRej(false);
        props.hideDialog();
        props.reloadTable();
    }
    const onSubmit = async (data: ITrainingSchedules) => {
        setLoading(true);
        const response = await Fetch("CarnivalTraining/updateTrainingSchedulesFormAction", "PUT", { Schedule_ID: props.singleData.schedule_ID, Schedule_Status: false, Rejection_Comment: data.rejection_Comment }, null, props.toast);

        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
            onHide();
        } else setLoading(false);
    }

    return (
        <Dialog visible={props.open} style={{ width: '42vw' }} header="Approve/Reject Schedule" modal className="p-fluid" onHide={onHide}>
            <div style={{ padding: "35px" }} className="flex align-items-center gap-3">
                <span className="pi pi-exclamation-triangle" style={{fontSize: "24px"}}></span> Please acknowledge this Schedule by choosing one of the following options.
            </div>
            <form className="p-fluid formgrid grid mt-3">
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px', background: "white", color: "#2196F3" }} label="Reject" onClick={() => onReject()} loading={loading} disabled={loading} type="button"></Button>
                    <Button style={{ width: '100px' }} label="Approve" onClick={() => onApprove()} loading={loading} disabled={loading} type="button"></Button>
                    {/* className="p-button-outlined surface-200" */}
                </div>
            </form>
            <Dialog visible={openRej} style={{ width: '60vw' }} header="Rejection Reason" modal className="p-fluid" onHide={() => setOpenRej(false)}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVInput required label="Rejection Reason" control={control} name="rejection_Comment" error={errors.rejection_Comment?.message} />
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading} disabled={loading}></Button>
                        <Button style={{ width: '100px' }} label="CLOSE" onClick={() => setOpenRej(false)} type="button" className="p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </Dialog>
        </Dialog>
    );
}